import { BodyM, Description } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import CasavoLogoSmall from '@/components/Icon/CasavoLogoSmall'
import Magnify from '@/components/Icon/Magnify'
import { flexCenter, paddingBottom, gap, marginTop } from '@/shared-styles/styles.css'
import { FilterByPrice, Money, Currency, Filter } from '@/types/graphql-generated-types'
import filtersMapper from '@/utils/filters-mapper'
import { formatPrice } from '@/utils/format-currency'

import { box } from '../../styles.css'
import { FilterInfo } from '../Common/FilterInfo'

import FeaturesList, { FilterArrayString } from './FeaturesList'

export const FiltersBoxSearchResults: React.FC<{ filters: Filter }> = ({ filters }) => {
  const { lang, t } = useTranslation()

  const formatFilterByPrice = (byPrice: FilterByPrice) => {
    const toMoney = (price: number): Money => {
      return {
        __typename: 'Money',
        cents: price * 100,
        currency: Currency.Eur,
      }
    }

    return filtersMapper.formatRange(
      formatPrice(toMoney(byPrice.from), lang),
      formatPrice(toMoney(byPrice.to), lang),
      t
    )
  }

  return (
    <div className={box}>
      <div className={[flexCenter, paddingBottom.m, gap.m].join(' ')}>
        <Magnify />
        <BodyM>{t('save-search:your_research')}</BodyM>
      </div>

      {filters.byResidentialType && (
        <FilterInfo
          className={paddingBottom['s-m']}
          label={t('filter:typology')}
          value={<FilterArrayString filterName="byResidentialType" filters={filters} />}
        />
      )}

      {filters.byPrice && <FilterInfo label={t('save-search:price')} value={formatFilterByPrice(filters.byPrice)} />}

      <FeaturesList filters={filters} />
      {filters.onlyCasavo && (
        <div className={[flexCenter, gap.s, marginTop.s].join(' ')}>
          <CasavoLogoSmall height="18px" width="16px" />
          <Description> {t('save-search:only_casavo')}</Description>
        </div>
      )}
    </div>
  )
}
